<template>
  <search-page-listing />
</template>

<script setup lang="ts">
import { updateSearchPageSeo } from "~/services/SEO/updateSearchPageSeo";

definePageMeta({
  layout: "default",
});

updateSearchPageSeo();
</script>
